import { Injectable, inject } from '@angular/core';
import { NavController } from '@ionic/angular/standalone';

/**
 * Forward navigation for public (unauthenticated) pages so {@link IonRouterOutlet} stack matches
 * in-app flow. Use from anchor {@code (click)}; keep {@code href} for accessibility and
 * middle-click/open in new tab.
 */
@Injectable({ providedIn: 'root' })
export class UnauthenticatedForwardNavService {
  private readonly navCtrl = inject(NavController);

  async forward(event: Event, url: string): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    await this.navCtrl.navigateForward(url);
  }
}
